import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationMarket } from '../../../api/types';

const usePriceDisclaimerToolTipByMarket = (market: ApplicationMarket) => {
    const { t } = useTranslation(['moduleDetails']);

    return useMemo(() => {
        switch (market) {
            case ApplicationMarket.Singapore:
                return t('moduleDetails:fields.priceDisclaimer.tooltipSG');
            case ApplicationMarket.NewZealand:
                return t('moduleDetails:fields.priceDisclaimer.tooltipNZ');
            default:
                return null;
        }
    }, [t, market]);
};

export default usePriceDisclaimerToolTipByMarket;
